import React from "react";

function OfTheDayResults({ results, searchTerm }) {
  return (
    <div>
      {results && results.otd && results.otd.posts !== 0 && (
        <div className="resultsGroup">
          <div className="sectionTitle">OF THE DAY</div>
          <div className="sectionList">
            <ul>
              {results && results.otd && results.otd.posts !== 0 && (
                <li>
                  »{" "}
                  <a href={`//www.dreamchimney.com/oftheday/search?terms=${searchTerm}`}>
                    {" "}
                    {results.otd.posts} result{results.otd.posts !== 0 ? `s` : ``} found
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

export default OfTheDayResults;
